import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Contact Us</h2>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h3>Location</h3>
                <p>
                  1410 Indiana Ave
                  <br />
                  Sheboygan, WI 53081
                </p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <div>
                <h3>Phone</h3>
                <p>(920) 316-2253</p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-clock"></i>
              <div>
                <h3>Hours</h3>
                <p>Mon-Sun: 11:00 AM - 9:00 PM</p>
              </div>
            </div>
          </div>

          <div className="other-locations">
            <h3>Other Himalayan Yak Group Locations</h3>
            <div className="location-item">
              <h4>Himalayan Yak - Milwaukee, WI</h4>
              <p>2321 S Kinnickinnic Ave, Milwaukee, WI 53207</p>
              <p>Phone: (414) 312-7223</p>
            </div>
            <div className="location-item">
              <h4>Himalayan Yak - Fargo, ND</h4>
              <p>1109 38th St S, Fargo, ND 58103</p>
              <p>Phone: (701) 532-1052</p>
            </div>
            <div className="location-item">
              <h4>Nanglo Momos & Curry - Appleton, WI</h4>
              <p>1619 W College Ave, Appleton, WI 54914</p>
              <p>Phone: (920) 257-4024</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
